import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import FormDataContext from "integrations/contexts/FormDataContext";
import Select from "components/common/Select";
import { Input } from "components/bootstrap";
import FormAdvancedOptions from "./FormAdvancedOptions";
import FormWrap from "../common/FormWrap";
const StepSubscribe = ({ onSubmit, onChange }) => {
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const [formError] = useState(null);
  const { pollingInterval } = formData;
  const availableLog = [
    { label: t("gcp.log_types.vpc_flow"), value: "VPC_FLOW_LOGS" },
    { label: t("gcp.log_types.firewall"), value: "FIREWALL_LOGS" },
    { label: t("gcp.log_types.audit_data_access"), value: "AUDIT_LOGS_DATA_ACCESS" },
    { label: t("gcp.log_types.audit_activity"), value: "AUDIT_LOGS_ACTIVITY" },
    { label: t("gcp.log_types.audit_system_event"), value: "AUDIT_LOGS_SYSTEM_EVENT" },
    { label: t("gcp.log_types.audit_policy_denied"), value: "AUDIT_LOGS_POLICY_DENIED" }
  ];
  const [logTypes, setLogTypes] = useState("");
  const [logTypeVal, setLogTypeVal] = useState(false);
  const handleSubmit = () => {
    if (logTypes.length === 0) {
      setLogTypeVal(true);
      return;
    }
    formData.logs.value = logTypes;
    onSubmit();
  };
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: t("common.buttons.proceed"),
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement("label", { className: "control-label", htmlFor: "logs" }, t("gcp.fields.logs_types")),
    /* @__PURE__ */ React.createElement(
      Select,
      {
        multi: true,
        name: "logs",
        id: "logs",
        onChange: (selected) => {
          setLogTypes(selected);
          setLogTypeVal(false);
        },
        options: availableLog,
        value: logTypes
      }
    ),
    logTypeVal && logTypes.length === 0 && /* @__PURE__ */ React.createElement("label", { htmlFor: "pollingInterval" }, t("gcp.fields.select_at_least_one")),
    /* @__PURE__ */ React.createElement("span", { className: "help-block" }, t("gcp.fields.logs_types_help")),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "pollingInterval",
        type: "number",
        value: pollingInterval.value || pollingInterval.defaultValue,
        min: "5",
        max: "60",
        onChange,
        required: true,
        help: t("gcp.fields.polling_interval_help"),
        label: t("common.fields.polling_interval")
      }
    ),
    /* @__PURE__ */ React.createElement(FormAdvancedOptions, { onChange })
  );
};
export default StepSubscribe;
